import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// --- Import your translation files ---
// Make sure these folders and files exist in src/locales/
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationDE from './locales/de/translation.json';
import translationES from './locales/es/translation.json';
import translationIT from './locales/it/translation.json';
import translationZH from './locales/zh/translation.json';
import translationJA from './locales/ja/translation.json';
import translationRU from './locales/ru/translation.json';
import translationAR from './locales/ar/translation.json';
import translationHI from './locales/hi/translation.json';

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  de: { translation: translationDE },
  es: { translation: translationES },
  it: { translation: translationIT },
  zh: { translation: translationZH },
  ja: { translation: translationJA },
  ru: { translation: translationRU },
  ar: { translation: translationAR }, // Fixed indentation
  hi: { translation: translationHI }
};

i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Use English if the detected language is not available
    debug: false,      // Set to true if you want to see language loading logs in console
    interpolation: {
      escapeValue: false // React already safes from xss
    }
  });

export default i18n;